/**
 * Custom Errors for Upload System
 * 
 * Provides specific error types to distinguish between different
 * failure modes during file uploads.
 */

/**
 * Custom error for user-initiated upload cancellation
 * 
 * This error is thrown when a user cancels an upload intentionally.
 * It should be caught and handled gracefully without showing error UI.
 */
export class UploadAbortedError extends Error {
  constructor() {
    super('Upload cancelled by user');
    this.name = 'UploadAbortedError';
  }
}

/**
 * Type guard to check if an error is an UploadAbortedError
 */
export function isUploadAbortedError(error: unknown): error is UploadAbortedError {
  return error instanceof UploadAbortedError;
}
